import { render, staticRenderFns } from "./agregarAsistente.vue?vue&type=template&id=6576a92c&"
import script from "./agregarAsistente.vue?vue&type=script&lang=js&"
export * from "./agregarAsistente.vue?vue&type=script&lang=js&"
import style0 from "./agregarAsistente.vue?vue&type=style&index=0&id=6576a92c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports